import i18n from '../i18n';

export default class ShipmentType {
  public static readonly NORMAL = new ShipmentType('1', '通常便Fedex');
  public static readonly S_DHL = new ShipmentType('2', '超速便DHL');
  public static readonly MATOME = new ShipmentType('3', '特殊便DHL');
  public static readonly S_FEDEX = new ShipmentType('4', '超速便Fedex');
  public static readonly UPS = new ShipmentType('5', 'UPS');

  public static values(): any {
    return [
      { value: this.NORMAL.value, text: i18n.t(this.NORMAL.text) },
      { value: this.S_DHL.value, text: i18n.t(this.S_DHL.text) },
      { value: this.MATOME.value, text: i18n.t(this.MATOME.text) },
      { value: this.S_FEDEX.value, text: i18n.t(this.S_FEDEX.text) },
    ];
  }

  public static filterValues(): any {
    return [
      { value: this.NORMAL.value, text: i18n.t(this.NORMAL.text) },
      { value: this.S_DHL.value, text: i18n.t(this.S_DHL.text) },
      { value: this.MATOME.value, text: i18n.t(this.MATOME.text) },
      { value: this.S_FEDEX.value, text: i18n.t(this.S_FEDEX.text) },
    ];
  }

  public static valuesTemporaly(): any {
    return [
      { value: this.NORMAL.value, text: i18n.t(this.NORMAL.text) },
      { value: this.S_DHL.value, text: i18n.t(this.S_DHL.text) },
      { value: this.MATOME.value, text: i18n.t(this.MATOME.text) },
      { value: this.S_FEDEX.value, text: i18n.t(this.S_FEDEX.text) },
      { value: this.UPS.value, text: i18n.t(this.UPS.text) },
    ];
  }

  public static valueOf(value: string): ShipmentType {
    for (const v of this.values()) {
      if (v.value === value) {
        return v;
      }
    }
    return ShipmentType.NORMAL;
  }

  public static getValue(value: string): string {
    if(value === '1'){
      return '通常便Fedex';
    } else if(value === '2'){
      return '超速便DHL';
    } else if(value === '3'){
      return '特殊便DHL';
    } else if(value === '4'){
      return '超速便Fedex';
    }  else{
      return 'UPS';
    }
  }

  private constructor(public readonly value: string, public readonly text: string) {}
  public getValue(): string { return this.value; }
  public getText(): string { return this.text; }
  public equals(other: ShipmentType): boolean { return (this.text === other.text) ? true : false; }
  public toString(): string { return `${this.text}(${this.text})`; }
}
